export const initialState = { data: null, loading: true, error: null };
export const PENDING = "PENDING";
export const FULFILLED = "FULFILLED";
export const REJECTED = "REJECTED";

export function init(initialResponse) {
  return { ...initialResponse };
}

function responseReducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case PENDING:
      return { ...initialState };
    case FULFILLED:
      return { data: payload, loading: false, error: null };
    case REJECTED:
      return { data: null, loading: false, error: payload };
    default:
      throw new Error("Unknown action type");
  }
}

export default responseReducer;
